var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationSchool01 = function SvgLocationSchool01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "location_school-01_svg2__a",
    x1: 44.85,
    x2: 162.53,
    y1: 164.23,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_school-01_svg2__a",
    id: "location_school-01_svg2__b",
    x1: 27.51,
    x2: 145.19,
    y1: 146.6,
    y2: 30.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_school-01_svg2__a",
    id: "location_school-01_svg2__c",
    x1: 43.64,
    x2: 161.32,
    y1: 163,
    y2: 47.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_school-01_svg2__a",
    id: "location_school-01_svg2__d",
    x1: 63.89,
    x2: 181.56,
    y1: 183.58,
    y2: 67.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_school-01_svg2__a",
    id: "location_school-01_svg2__e",
    x1: 35.02,
    x2: 152.7,
    y1: 154.23,
    y2: 38.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_school-01_svg2__a",
    id: "location_school-01_svg2__f",
    x1: 63.65,
    x2: 181.32,
    y1: 183.34,
    y2: 67.61
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.55 116.13H67.74c-1.78 0-3.23 1.44-3.23 3.23v19.36c0 1.78 1.44 3.23 3.23 3.23h25.81c1.78 0 3.23-1.44 3.23-3.23v-19.36c0-1.78-1.44-3.23-3.23-3.23m-3.23 19.35H70.96v-12.9h19.36z",
    style: {
      fill: "url(#location_school-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.58 154.84h19.35c1.78 0 3.23-1.44 3.23-3.23v-19.35c0-1.78-1.44-3.23-3.23-3.23H22.58c-1.78 0-3.23 1.44-3.23 3.23v19.35c0 1.78 1.44 3.23 3.23 3.23m3.23-19.36h12.9v12.9h-12.9z",
    style: {
      fill: "url(#location_school-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.58 187.1h19.35c1.78 0 3.23-1.44 3.23-3.23v-19.35c0-1.78-1.44-3.23-3.23-3.23H22.58c-1.78 0-3.23 1.44-3.23 3.23v19.35c0 1.78 1.44 3.23 3.23 3.23m3.23-19.36h12.9v12.9h-12.9z",
    style: {
      fill: "url(#location_school-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23 119.35v19.36c0 1.78 1.44 3.23 3.23 3.23h25.81c1.78 0 3.23-1.44 3.23-3.23v-19.36c0-1.78-1.44-3.23-3.23-3.23h-25.81c-1.78 0-3.23 1.44-3.23 3.23m6.45 3.23h19.35v12.9h-19.35z",
    style: {
      fill: "url(#location_school-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87 90.32c0 8.91 7.22 16.13 16.13 16.13s16.13-7.22 16.13-16.13-7.22-16.13-16.13-16.13c-8.9.01-16.12 7.23-16.13 16.13m25.81 0c0 5.34-4.33 9.68-9.68 9.68s-9.68-4.33-9.68-9.68 4.33-9.68 9.68-9.68 9.68 4.33 9.68 9.68",
    style: {
      fill: "url(#location_school-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.77 122.58c1.78 0 3.23-1.44 3.23-3.23v-12.9c0-1.78-1.44-3.23-3.23-3.23h-48.39v-8.84c5.03 1.79 10.57-.83 12.36-5.87 1.45-4.08.02-8.63-3.51-11.14L105.62 40.5c-.74-.52-1.55-.93-2.4-1.23V25.79h22.58c1.78 0 3.23-1.44 3.23-3.23V3.23c0-1.78-1.44-3.23-3.23-3.23H99.99c-1.78 0-3.23 1.44-3.23 3.23v36.06c-.85.29-1.66.71-2.4 1.23L42.75 77.39c-4.36 3.09-5.38 9.14-2.29 13.49a9.674 9.674 0 0 0 11.14 3.51v8.84H3.23c-1.78 0-3.23 1.44-3.23 3.23v12.9c0 1.78 1.44 3.23 3.23 3.23h3.23v70.97H3.23C1.45 193.56 0 195 0 196.79s1.44 3.23 3.23 3.23h193.55c1.78 0 3.23-1.44 3.23-3.23s-1.44-3.23-3.23-3.23h-3.23v-70.97h3.23ZM103.23 6.45h19.35v12.9h-19.35zm-51.62 187.1H12.9v-70.97h38.71zm0-77.42H6.45v-6.45h45.16zm-1.35-28.25c-1.45 1.03-3.46.7-4.5-.75a3.227 3.227 0 0 1 .75-4.5l51.61-36.87c1.12-.8 2.63-.8 3.75 0l51.61 36.87c.85.61 1.35 1.58 1.35 2.63a3.229 3.229 0 0 1-5.1 2.63L101.87 53.7a3.23 3.23 0 0 0-3.75 0L50.26 87.89Zm46.51 105.67h-12.9v-38.71h12.9zm19.36 0h-12.9v-38.71h12.9zm25.81 0h-19.35v-41.94c0-1.78-1.44-3.23-3.23-3.23H80.65c-1.78 0-3.23 1.44-3.23 3.23v41.94H58.07V90.24l41.94-29.95 41.94 29.95v103.31Zm45.16 0h-38.71v-70.97h38.71zm-38.71-77.42v-6.45h45.16v6.45z",
    style: {
      fill: "url(#location_school-01_svg2__f)"
    }
  }));
};
export default SvgLocationSchool01;